import {
	ServiceProviderServiceInterface,
	ServiceProvider,
	SingleResponse,
	ListResponse,
	APIClientInterface,
	User,
	Reseller,
	UserFormValues,
	ReportEntry,
	ServiceProvidersLicenseUsage,
	ReportType, ResellerLicense
} from '../types'

export default class ServiceProviderService implements ServiceProviderServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async getAll(): Promise<ListResponse<ServiceProvider>> {
		return this.client.get(`/serviceproviders`)
	}

	public async getById(id: number): Promise<SingleResponse<ServiceProvider>> {
		return this.client.get(`/serviceproviders/${id}`)
	}

	public async getChildren(id: number): Promise<SingleResponse<Reseller[]>> {
		return this.client.get(`/serviceproviders/${id}/resellers`)
	}

	public async getUsers(id: number): Promise<SingleResponse<User[]>> {
		return this.client.get(`/serviceproviders/${id}/users`)
	}

	public async createUserForServiceProvider(id: number, values: UserFormValues): Promise<SingleResponse<User>> {
		return this.client.post(`/serviceproviders/${id}/users`, JSON.stringify(values))
	}

	public async updateUserForServiceProvider(id: number, userId: number, values: UserFormValues): Promise<SingleResponse<User>> {
		return this.client.patch(`/serviceproviders/${id}/users/${userId}`, JSON.stringify(values))
	}

	public async deleteUserForServiceProvider(id: number, userId: number): Promise<void> {
		return this.client.delete(`/serviceproviders/${id}/users/${userId}`)
	}

	public async updateTemplateIdForServiceProvider(id: number, templateId: string): Promise<SingleResponse<ServiceProvider>> {
		return this.client.patch(`/serviceproviders/${id}`, JSON.stringify({ template_id: templateId }))
	}

	public async getReport(id: number): Promise<ListResponse<ReportEntry>> {
		return this.client.get(`/serviceproviders/${id}/report`)
	}

	public async getCsvReport(id: number, type: ReportType): Promise<SingleResponse<string>> {
		return this.client.get(`/serviceproviders/${id}/report/csv/${type}`)
	}

	public async getLicenseUsageReport(): Promise<SingleResponse<ServiceProvidersLicenseUsage[]>> {
		return this.client.get(`/serviceproviders/licenseusagereport`)
	}

	public async getLicenses(id: number): Promise<SingleResponse<Record<string, ResellerLicense>>> {
		return this.client.get(`/serviceproviders/${id}/licenses`)
	}

	public async updateLicense(id: number, type: string, values: Partial<ResellerLicense>): Promise<void> {
		return this.client.patch(`/serviceproviders/${id}/licenses/${type}`, JSON.stringify(values))
	}
}
